import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

/* Tema bağlamı — açık/koyu mod tercihini uygulama genelinde yönetir */
const ThemeContext = createContext({ theme: 'light', toggleTheme: () => {} });

const STORAGE_KEY = 'atunears.theme';

/* Tarayıcı tercihi ve localStorage'tan başlangıç temasını belirler */
function getInitialTheme() {
  try {
    const stored = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
    if (stored === 'light' || stored === 'dark') {
      return stored;
    }
  } catch (exception) {
    /* localStorage erişimi engellenmiş olabilir; sessizce varsayılana düş */
  }
  return 'light';
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  /* Tema değiştiğinde HTML kök öğesine data-theme niteliği uygulanır */
  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-theme', theme);
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch (exception) {
      /* Yazma hatasını yoksay */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((current) => (current === 'light' ? 'dark' : 'light'));
  }, []);

  const value = useMemo(() => ({ theme, toggleTheme, setTheme }), [theme, toggleTheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
